import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d2ac6b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../../../../assets/logo.png"
}, null, -1))
const _hoisted_2 = { class: "inner_step_box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "4.1 Установка карты", -1))
const _hoisted_4 = { style: {"margin-top":"10px","margin-left":"6px"} }
const _hoisted_5 = ["checked"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "main_field unselectable",
  style: {"line-height":"47px"},
  for: "r1"
}, "  Использовать сервис Яндекс.Карты ", -1))
const _hoisted_7 = { style: {"margin-bottom":"10px","margin-left":"6px"} }
const _hoisted_8 = ["checked"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "main_field unselectable",
  style: {"line-height":"47px"},
  for: "r2"
}, "  Загрузить файл карты формата 1:2000 ", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "hint_left hint_mini_top" }
const _hoisted_12 = {
  key: 1,
  style: {"margin-left":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu_list = _resolveComponent("v-menu-list")!
  const _component_YandexMap = _resolveComponent("YandexMap")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_menu_list),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", {
          type: "radio",
          class: "map_radio",
          name: "map_radio",
          value: "1",
          id: "r1",
          checked: 1 == _ctx.storeDM.save_obj.mapfile_type,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.storeDM.save_obj.mapfile_type = 1))
        }, null, 8, _hoisted_5),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("input", {
          type: "radio",
          class: "map_radio",
          name: "map_radio",
          value: "0",
          id: "r2",
          checked: 0 == _ctx.storeDM.save_obj.mapfile_type,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.storeDM.save_obj.mapfile_type = 0))
        }, null, 8, _hoisted_8),
        _hoisted_9
      ]),
      (0 == _ctx.storeDM.save_obj.mapfile_type)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.map_file_hint), 1),
            _createElementVNode("input", {
              ref: "map_file",
              type: "file",
              hidden: "",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitFile('map_file')))
            }, null, 544),
            _createElementVNode("button", {
              type: "button",
              class: "blue_btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$refs.map_file.click())),
              style: {"float":"left","margin-left":"10px"}
            }, " Загрузить картинку с картой - 1.5 к 1 (горизонтальная картинка) ")
          ]))
        : _createCommentVNode("", true),
      (1 == _ctx.storeDM.save_obj.mapfile_type)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_YandexMap, {
              address_line: 
          'Санкт-Петербург, ' +
          _ctx.storeDM.save_obj.map_street +
          ' ' +
          _ctx.storeDM.save_obj.map_address +
          ', ' +
          _ctx.storeDM.save_obj.map_house
        
            }, null, 8, ["address_line"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.go_back()))
    }, "Назад"),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["next_btn", { active_btn: true }]),
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.go_next()))
    }, " Далее ")
  ], 64))
}